/* Jireh Threads shared features: cart helper, wishlist hearts, Quick view.
   Everything is rendered with textContent / createElement (no HTML from data). */
(function () {
  'use strict';
  if (window.JT && window.JT.ready) return;
  var JT = (window.JT = window.JT || {});
  JT.ready = true;

  var ROUTES = window.routes || {};
  var CART_ADD = (ROUTES.cart_add_url || '/cart/add') + '.js';
  var money = function (cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  JT.money = money;
  var el = function (tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
  var validHandle = function (h) { return typeof h === 'string' && /^[a-z0-9][a-z0-9-]{0,199}$/.test(h); };
  JT.validHandle = validHandle;

  // ---------- Cart: add one or many items, refresh the drawer and bubble ----------
  JT.addToCart = function (items) {
    items = (items || []).filter(function (i) { return i && /^\d+$/.test(String(i.id)) && i.quantity > 0; });
    if (!items.length) return Promise.reject(new Error('Nothing to add'));
    return fetch(CART_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) throw new Error(res.description || res.message || 'Could not add to cart');
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && res.sections && res.sections['cart-icon-bubble']) {
        var d = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (d) bubble.innerHTML = d.innerHTML; // markup rendered by Shopify for this store
      }
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents({ id: items[0].id, sections: res.sections });
      } else {
        location.href = ROUTES.cart_url || '/cart';
      }
      document.dispatchEvent(new CustomEvent('jt:cart-updated'));
      return res;
    });
  };

  // ---------- Wishlist (saved in this browser) ----------
  var WKEY = 'jt-wish';
  JT.wishlist = {
    get: function () { try { var a = JSON.parse(localStorage.getItem(WKEY)) || []; return a.filter(validHandle).slice(0, 60); } catch (e) { return []; } },
    set: function (a) { try { localStorage.setItem(WKEY, JSON.stringify(a.filter(validHandle).slice(0, 60))); } catch (e) {} sync(); },
    has: function (h) { return JT.wishlist.get().indexOf(h) > -1; },
    toggle: function (h) {
      if (!validHandle(h)) return false;
      var a = JT.wishlist.get(), i = a.indexOf(h);
      if (i > -1) a.splice(i, 1); else a.unshift(h);
      JT.wishlist.set(a);
      return i < 0;
    }
  };
  function sync() {
    var list = JT.wishlist.get();
    document.querySelectorAll('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('[data-wish-count]').forEach(function (c) { c.textContent = list.length ? String(list.length) : ''; c.hidden = !list.length; });
  }
  JT.syncWishlist = sync;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var on = JT.wishlist.toggle(b.getAttribute('data-wish'));
    b.classList.add('is-pop'); setTimeout(function () { b.classList.remove('is-pop'); }, 400);
    toast(on ? 'Saved to your wishlist' : 'Removed from your wishlist', on ? (ROUTES.wishlist_url || '/collections/all?view=wishlist') : null);
  });

  // Small status toast
  var toastEl;
  function toast(msg, link) {
    if (!toastEl) { toastEl = el('div', 'jt-toast'); toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    if (link) { var a = el('a', null, 'View'); a.href = link; toastEl.appendChild(a); }
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }
  JT.toast = toast;

  // ---------- Quick view ----------
  var qv, qvBody, lastFocus;
  function buildModal() {
    qv = el('div', 'jt-qv'); qv.hidden = true;
    qv.setAttribute('role', 'dialog'); qv.setAttribute('aria-modal', 'true'); qv.setAttribute('aria-label', 'Quick view');
    var card = el('div', 'jt-qv__card');
    var x = el('button', 'jt-qv__x', '×'); x.type = 'button'; x.setAttribute('aria-label', 'Close quick view');
    qvBody = el('div', 'jt-qv__body');
    card.appendChild(x); card.appendChild(qvBody); qv.appendChild(card); document.body.appendChild(qv);
    x.addEventListener('click', closeQV);
    qv.addEventListener('click', function (e) { if (e.target === qv) closeQV(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !qv.hidden) closeQV(); });
  }
  function closeQV() { qv.hidden = true; document.documentElement.classList.remove('jt-noscroll'); if (lastFocus) lastFocus.focus(); }

  function openQV(handle) {
    if (!validHandle(handle)) return;
    if (!qv) buildModal();
    lastFocus = document.activeElement;
    qvBody.textContent = ''; qvBody.appendChild(el('p', 'jt-qv__loading', 'Loading…'));
    qv.hidden = false; document.documentElement.classList.add('jt-noscroll');
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('not found'); return r.json(); })
      .then(function (p) { renderQV(p); })
      .catch(function () { qvBody.textContent = ''; qvBody.appendChild(el('p', 'jt-qv__loading', 'Sorry, this item couldn’t be loaded.')); });
  }

  function renderQV(p) {
    qvBody.textContent = '';
    var grid = el('div', 'jt-qv__grid');
    var media = el('div', 'jt-qv__media');
    var imgs = (p.images || []).slice(0, 6);
    var main = el('img'); main.alt = p.title; main.width = 600; main.height = 800;
    var src = function (u, w) { return (u.indexOf('//') === 0 ? 'https:' + u : u) + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
    if (imgs[0]) main.src = src(imgs[0], 700);
    media.appendChild(main);
    if (imgs.length > 1) {
      var th = el('div', 'jt-qv__thumbs');
      imgs.forEach(function (u) { var b = el('button'); b.type = 'button'; b.setAttribute('aria-label', 'Show photo'); var i = el('img'); i.src = src(u, 120); i.alt = ''; b.appendChild(i); b.addEventListener('click', function () { main.src = src(u, 700); }); th.appendChild(b); });
      media.appendChild(th);
    }
    var info = el('div', 'jt-qv__info');
    info.appendChild(el('h2', 'jt-qv__title', p.title));
    var price = el('p', 'jt-qv__price'); info.appendChild(price);

    // options
    var opts = (p.options || []).map(function (o) { return typeof o === 'string' ? { name: o } : o; });
    var chosen = [];
    var first = (p.variants || []).find(function (v) { return v.available; }) || p.variants[0];
    opts.forEach(function (o, i) { chosen[i] = first.options[i]; });
    var stock = el('p', 'jt-qv__stock');
    var add = el('button', 'jt-qv__add', 'Add to cart'); add.type = 'button';
    var current;
    function findV() { return p.variants.find(function (v) { return v.options.every(function (x, i) { return x === chosen[i]; }); }); }
    function refresh() {
      current = findV();
      price.textContent = current ? money(current.price) : '';
      if (current && current.compare_at_price > current.price) { var s = el('s', null, money(current.compare_at_price)); price.appendChild(s); }
      add.disabled = !current || !current.available;
      add.textContent = !current ? 'Unavailable' : current.available ? 'Add to cart' : 'Sold out';
      stock.textContent = current && current.available ? 'In stock, ready to ship' : 'This option is sold out';
      stock.className = 'jt-qv__stock' + (current && current.available ? '' : ' is-out');
      info.querySelectorAll('.jt-qv__opt button').forEach(function (b) {
        var gi = +b.dataset.i, val = b.dataset.v, trial = chosen.slice(); trial[gi] = val;
        var v = p.variants.find(function (x) { return x.options.every(function (y, k) { return y === trial[k]; }); });
        b.classList.toggle('is-out', !v || !v.available);
        b.setAttribute('aria-pressed', chosen[gi] === val ? 'true' : 'false');
      });
    }
    opts.forEach(function (o, i) {
      var vals = []; p.variants.forEach(function (v) { if (vals.indexOf(v.options[i]) < 0) vals.push(v.options[i]); });
      if (vals.length < 2) return;
      var g = el('div', 'jt-qv__opt');
      g.appendChild(el('span', 'jt-qv__opt-l', o.name));
      var row = el('div', 'jt-qv__opt-v');
      vals.forEach(function (val) {
        var b = el('button', null, val); b.type = 'button'; b.dataset.i = i; b.dataset.v = val;
        b.addEventListener('click', function () { chosen[i] = val; refresh(); });
        row.appendChild(b);
      });
      g.appendChild(row); info.appendChild(g);
    });
    info.appendChild(stock);
    add.addEventListener('click', function () {
      if (!current || !current.available) return;
      add.disabled = true; add.textContent = 'Adding…';
      JT.addToCart([{ id: current.id, quantity: 1 }]).then(function () { closeQV(); })
        .catch(function (e) { add.disabled = false; add.textContent = 'Add to cart'; toast(e.message || 'Could not add to cart'); });
    });
    var row2 = el('div', 'jt-qv__actions'); row2.appendChild(add);
    var heart = el('button', 'jt-heart jt-heart--inline'); heart.type = 'button'; heart.setAttribute('data-wish', p.handle); heart.setAttribute('aria-label', 'Save to wishlist');
    heart.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7-4.4-9.2-8.6C1.2 8.3 3 5 6.2 5c2 0 3.2 1.1 3.8 2.2C10.6 6.1 11.8 5 13.8 5c3.2 0 5 3.3 3.4 6.4C19 15.6 12 20 12 20z"/></svg>'; // static icon markup
    row2.appendChild(heart); info.appendChild(row2);
    var more = el('a', 'jt-qv__more', 'See full details →'); more.href = '/products/' + p.handle; info.appendChild(more);
    grid.appendChild(media); grid.appendChild(info); qvBody.appendChild(grid);
    refresh(); sync();
    var firstBtn = qvBody.querySelector('button'); if (firstBtn) firstBtn.focus();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quickview]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    openQV(b.getAttribute('data-quickview'));
  });
  JT.quickView = openQV;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
  document.addEventListener('shopify:section:load', sync);
  // Collection filtering re-renders the grid; keep hearts in sync
  var raf = 0;
  new MutationObserver(function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sync(); }); }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
